// caiet UC91-06 — a date range is two calendar days, and three processes have to
// agree on what one is: the screen decides whether a custom interval can be asked
// for, the bff refuses one it cannot read, and analytics refuses one for any other
// caller. A `YYYY-MM-DD` shape alone admits `2026-02-30`, which reaches Postgres
// and comes back as a 500, so the day must also exist.
// Reference: docs/shape-uc-91-time-window.md §2.
const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

export function isCalendarDay(value: unknown): value is string {
  if (typeof value !== 'string' || !ISO_DAY.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}
